import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useClerk } from '@/hooks/useClerk'
import { signInUrl, signUpUrl } from '@/lib/auth'

export default function LoginPage() {
  const { ready, clerk } = useClerk()
  const [params] = useSearchParams()
  const isSignup = params.get('signup') === '1'
  // PatientLayout sends us here with ?reauth=1 when the backend rejected the
  // Clerk session. Clear the stale session before handing off to the portal so
  // it shows a fresh sign-in rather than silently re-authing the bad session.
  const isReauth = params.get('reauth') === '1'

  useEffect(() => {
    const dest = isSignup ? signUpUrl() : signInUrl()

    // Normal entry — straight to the Clerk Account Portal. `replace` keeps
    // /login out of history so the back button can't bounce here in a loop.
    if (!isReauth) {
      window.location.replace(dest)
      return
    }

    // Reauth — wait for clerk-js, drop the rejected session, then hand off.
    if (!ready || !clerk) return
    Promise.resolve(clerk.signOut?.())
      .catch(() => {})
      .finally(() => window.location.replace(dest))
  }, [ready, clerk, isSignup, isReauth])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-bg px-4 py-8">
      <span className="mb-6 text-center font-serif italic text-[1.8rem] font-normal tracking-[-0.02em] text-ink-primary">
        Pelvia
      </span>
      <span className="text-sm text-ink-muted">Redirecting to sign in…</span>
    </div>
  )
}
